import PropTypes from 'prop-types';
import { CatIconLock } from '@blocks-react/components/Icons/Lock';
import { CatIconPeople } from '@blocks-react/components/Icons/People';
import { CatIconDealer } from '@blocks-react/components/Icons/Dealer';
import { LIST_TYPES } from '../../../constants';

const ListTypeCell = ({ type }) => {
  let icon;
  if (type === LIST_TYPES.PRIVATE) {
    icon = <CatIconLock />;
  } else if (type === LIST_TYPES.SHARED) {
    icon = <CatIconPeople />;
  } else {
    icon = <CatIconDealer />;
  }
  return <div className="d-flex justify-content-center">{icon}</div>;
};

export default ListTypeCell;

ListTypeCell.propTypes = {
  type: PropTypes.string
};
